import qs from 'query-string';
import { CusatFilters, CusatSort } from '../interfaces';

export const buildCusatQuery = (
  filters: CusatFilters,
  sort: CusatSort,
  pagination?: { page: number; limit: number },
): string =>
  qs.stringify(
    {
      ...filters,
      accountName: filters.accountName?.trim() || null,
      ...sort,
      ...pagination,
    },
    { skipNull: true, skipEmptyString: true },
  );
